<mat-accordion class="mat-elevation-z0">
  <mat-expansion-panel class="mat-elevation-z0">
    <mat-expansion-panel-header class="filtros">
      <mat-panel-title>
        Filtros
      </mat-panel-title>
      <mat-panel-description>
        Adicione filtros à sua busca
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div fxLayout="row" class="inputs" [formGroup]="form">
      <mat-form-field>
        <input matInput formControlName="valorCheque" placeholder="Valor do Cheque" currencyMask>
      </mat-form-field>

      <!-- <mat-form-field>
        <input matInput formControlName="chequeMaximo" placeholder="Cheque Máximo" currencyMask>
      </mat-form-field> -->

      <a class="btn table-btn" title="Buscar"
        (click)="aplicarFiltroFundo()">
        <icons-primecap name="pesquisa"></icons-primecap>
      </a>

      <button-primecap class="float-right"
        buttonClass="secundario-button"
        label="Limpar Filtros"
        [icon]="true"
        nomeIcon="lixeira"
        (clickButton)="limparFiltro()">
      </button-primecap>

    </div>

    <mat-accordion class="mat-elevation-z0">
      <mat-expansion-panel class="mat-elevation-z0" (opened)="abrirPainelSetores = true" (closed)="abrirPainelSetores = false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Setores
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row">
          <div class="col-2" *ngFor="let setor of listaSetores">
            <mat-checkbox color="primary" (change)="adicionarFiltroCheckbox(setor, tipoFiltro.S)" [(ngModel)]="setor.checked">{{ setor.nome }}</mat-checkbox>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion class="mat-elevation-z0">
      <mat-expansion-panel class="mat-elevation-z0" (opened)="abrirPainelMomentos = true" (closed)="abrirPainelMomentos = false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Momentos
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row">
          <div class="col-2"  *ngFor="let momento of listaMomentos">
            <mat-checkbox color="primary" (change)="adicionarFiltroCheckbox(momento, tipoFiltro.M)" [(ngModel)]="momento.checked">{{ momento.nome }}</mat-checkbox>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

  </mat-expansion-panel>
</mat-accordion>
